import { useTranslation } from "react-i18next"

/**
 * The language switch of the screens outside the shell: one plain button
 * naming the other language in that language ("English" on a French page),
 * so a visitor who cannot read the page can still find it. No menu, so the
 * sign-in screen carries no Radix (NFR-DSH-01).
 */
export function AuthLanguageSwitch() {
  const { t, i18n } = useTranslation("common")
  const other = i18n.language === "en" ? "fr" : "en"
  return (
    <button
      type="button"
      title={t("language.switchTo")}
      className="rounded-md px-3 py-2 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-none max-md:min-h-11"
      onClick={() => {
        void i18n.changeLanguage(other)
      }}
    >
      <span lang={other}>{t(`language.endonym.${other}`)}</span>
    </button>
  )
}
